import { ControllerFont, makeStyles } from '@bymason-private/controller-v1-theme-provider';
import {
  Card,
  CardActions,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Text,
  CardActionArea,
} from '@bymason-private/legacy-pattern-components';
import { DetailItemIcon, DetailItemType } from '@bymason-private/controller-shared-widgets';

const useStyles = makeStyles((theme) => ({
  card: {
    ...ControllerFont.Body400R,
    borderColor: theme.palette.grey[400],
    borderRadius: 4,
    height: 164,
    '&:hover': {
      boxShadow: theme.shadows[1],
    },
  },
  cardActionArea: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'stretch',
    height: '100%',
  },
  title: {
    ...ControllerFont.Heading300B,
  },
  description: {
    maxHeight: 80,
    overflowY: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 4,
    whiteSpace: 'break-spaces',
  },
  cardActions: {
    paddingBottom: 0,
  },
  list: {
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderTopColor: theme.palette.grey[400],
    display: 'flex',
    width: '100%',
    '& > *': {
      flexBasis: '10px',
      marginRight: 16,
    },
    '& > *:last-child': {
      flexGrow: 1,
    },
  },
  icon: {
    marginTop: 5,
    minWidth: 24,
  },
}));

export default function InfoCard({ title, description, href, detailItems = [], onClick }: InfoCardProps) {
  const classes = useStyles();

  return (
    <Card className={classes.card} variant='outlined'>
      {/* CardActionArea inherits ButtonBase, so href works but gives TS error */}
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment*/}
      {/* @ts-ignore */}
      <CardActionArea className={classes.cardActionArea} href={href} onClick={onClick}>
        <CardContent>
          <Text className={classes.title} component='div'>
            {title}
          </Text>
          <Text className={classes.description} component='div' variant='body2'>
            {description}
          </Text>
        </CardContent>
        <CardActions className={classes.cardActions}>
          <List className={classes.list} disablePadding dense>
            {detailItems.map((item, idx) => (
              <ListItem key={item.type + idx} alignItems='flex-start' disableGutters>
                <ListItemIcon className={classes.icon}>
                  <DetailItemIcon type={item.type} />
                </ListItemIcon>
                <ListItemText primary={item.value} primaryTypographyProps={{ whiteSpace: 'nowrap' }} />
              </ListItem>
            ))}
          </List>
        </CardActions>
      </CardActionArea>
    </Card>
  );
}

export interface DetailItem {
  value: string;
  type: DetailItemType;
}
export interface InfoCardProps {
  description?: string;
  detailItems?: DetailItem[];
  title: string;
  href?: string;
  onClick?: (evt: React.MouseEvent<HTMLAnchorElement>) => void;
}
